export default {
  translation: {
    common: {
      save: 'Lưu',
      cancel: 'Hủy',
      delete: 'Xóa',
      edit: 'Sửa',
      add: 'Thêm',
      search: 'Tìm kiếm',
      loading: 'Đang tải...',
      success: 'Thành công',
      error: 'Lỗi',
      confirm: 'Xác nhận',
      yes: 'Có',
      no: 'Không',
      back: 'Quay lại',
      next: 'Tiếp theo',
      submit: 'Gửi',
      close: 'Đóng',
      required: 'Bắt buộc',
      optional: 'Tùy chọn',
    },
    auth: {
      login: 'Đăng nhập',
      logout: 'Đăng xuất',
      register: 'Đăng ký',
      email: 'Email',
      password: 'Mật khẩu',
      confirmPassword: 'Xác nhận mật khẩu',
      forgotPassword: 'Quên mật khẩu?',
      resetPassword: 'Đặt lại mật khẩu',
      loginSuccess: 'Đăng nhập thành công',
      logoutSuccess: 'Đăng xuất thành công',
      invalidCredentials: 'Email hoặc mật khẩu không đúng',
      emailSent: 'Đã gửi email đặt lại mật khẩu',
    },
    household: {
      title: 'Hộ gia đình',
      createHousehold: 'Tạo hộ gia đình',
      householdName: 'Tên hộ gia đình',
      householdAddress: 'Địa chỉ',
      members: 'Thành viên',
      addMember: 'Thêm thành viên',
      removeMember: 'Xóa thành viên',
      switchHousehold: 'Chuyển hộ gia đình',
      currentHousehold: 'Hộ gia đình hiện tại',
      noHousehold: 'Không có hộ gia đình',
    },
    task: {
      title: 'Công việc',
      createTask: 'Tạo công việc',
      taskTitle: 'Tiêu đề',
      description: 'Mô tả',
      dueDate: 'Hạn hoàn thành',
      priority: 'Độ ưu tiên',
      status: 'Trạng thái',
      category: 'Danh mục',
      assignTo: 'Giao cho',
      startTask: 'Bắt đầu',
      finishTask: 'Hoàn thành',
      completeTask: 'Xong',
      cancelTask: 'Hủy',
      taskStarted: 'Đã bắt đầu công việc',
      taskFinished: 'Đã hoàn thành công việc',
      taskCompleted: 'Công việc đã xong',
      taskCancelled: 'Công việc đã bị hủy',
      highPriority: 'Cao',
      mediumPriority: 'Trung bình',
      lowPriority: 'Thấp',
      pending: 'Chờ xử lý',
      inProgress: 'Đang thực hiện',
      completed: 'Hoàn thành',
      cancelled: 'Đã hủy',
    },
    expense: {
      title: 'Chi phí',
      createExpense: 'Thêm chi phí',
      amount: 'Số tiền',
      category: 'Danh mục',
      date: 'Ngày',
      description: 'Mô tả',
      receipt: 'Biên lai',
      verify: 'Xác minh',
      verified: 'Đã xác minh',
      pending: 'Chờ xử lý',
      rejected: 'Từ chối',
    },
    quotation: {
      title: 'Báo giá',
      createQuotation: 'Tạo báo giá',
      vendor: 'Nhà cung cấp',
      totalAmount: 'Tổng số tiền',
      validUntil: 'Có hiệu lực đến',
      approve: 'Phê duyệt',
      reject: 'Từ chối',
      approved: 'Đã phê duyệt',
      rejected: 'Đã từ chối',
      pending: 'Chờ xử lý',
    },
    mealPlan: {
      title: 'Kế hoạch bữa ăn',
      createMealPlan: 'Tạo kế hoạch bữa ăn',
      date: 'Ngày',
      mealType: 'Loại bữa ăn',
      breakfast: 'Bữa sáng',
      lunch: 'Bữa trưa',
      dinner: 'Bữa tối',
      snack: 'Ăn nhẹ',
      approve: 'Phê duyệt',
      reject: 'Từ chối',
      aiRecommend: 'Gợi ý AI',
    },
    notification: {
      title: 'Thông báo',
      markAsRead: 'Đánh dấu đã đọc',
      markAllRead: 'Đánh dấu tất cả đã đọc',
      noNotifications: 'Không có thông báo',
      taskReminder: 'Nhắc nhở công việc',
      expenseApproved: 'Chi phí đã được phê duyệt',
      quotationApproved: 'Báo giá đã được phê duyệt',
    },
    settings: {
      title: 'Cài đặt',
      language: 'Ngôn ngữ',
      theme: 'Giao diện',
      notifications: 'Thông báo',
      account: 'Tài khoản',
      privacy: 'Quyền riêng tư',
      about: 'Giới thiệu',
      version: 'Phiên bản',
      logout: 'Đăng xuất',
    },
    role: {
      employer: 'Người sử dụng lao động',
      maid: 'Người giúp việc',
      familyMember: 'Thành viên gia đình',
      admin: 'Quản trị viên',
    },
    backup: {
      title: 'Sao lưu & Khôi phục',
      createBackup: 'Tạo bản sao lưu',
      restoreBackup: 'Khôi phục bản sao lưu',
      lastBackup: 'Sao lưu gần nhất',
      backupSuccess: 'Sao lưu thành công',
      restoreSuccess: 'Khôi phục thành công',
    },
    export: {
      title: 'Xuất dữ liệu',
      exportCSV: 'Xuất CSV',
      exportPDF: 'Xuất PDF',
      exportJSON: 'Xuất JSON',
      exportSuccess: 'Xuất dữ liệu thành công',
    },
  },
}
